const urlInputSelector = `.js--url-without-scheme`
const completeUrlSchemePattern = /^\s*(?:https?[\\/:\s]+)+(?=\S)/i
const urlSchemePattern = /^\s*(?:https?[\\/:\s]+)+/i

const removeUrlScheme = (input, pattern) => {
  const normalizedValue = input.value.replace(pattern, ``)
  if (normalizedValue === input.value) return

  const removedCharacterCount = input.value.length - normalizedValue.length
  const selectionStart = input.selectionStart
  const selectionEnd = input.selectionEnd

  input.value = normalizedValue

  if (selectionStart !== null && selectionEnd !== null) {
    input.setSelectionRange(
      Math.max(0, selectionStart - removedCharacterCount),
      Math.max(0, selectionEnd - removedCharacterCount)
    )
  }
}

document.addEventListener(`input`, (event) => {
  if (!(event.target instanceof HTMLInputElement)) return
  if (!event.target.matches(urlInputSelector)) return

  removeUrlScheme(event.target, completeUrlSchemePattern)
})

document.addEventListener(`change`, (event) => {
  if (!(event.target instanceof HTMLInputElement)) return
  if (!event.target.matches(urlInputSelector)) return

  removeUrlScheme(event.target, urlSchemePattern)
})
